import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import SchduleImg from '../../assets/images/products/schduleImg.png'
import TrailoredImg from '../../assets/images/products/tailored.svg'
import LiveQA from '../../assets/images/products/liveQA.svg'
import RoadMap from '../../assets/images/products/roadmap.svg'

const GetDemo = () => {
  return (
    <>
    <div className="getDemoPage">
        <Navbar/>
        <div className="scheduleWalkthroughSection">
            <div className="container">
                <div className="seePranActionRow">
                    <div className="seePranActionLeftColum">
                        <span>Schedule a Walkthrough</span>
                        <h3>See Pran.AI in Action</h3>
                        <div className="seePranCard">
                            <div className="seepranImg"><img src={TrailoredImg} alt="Tailored" /></div>
                            <div className="seepranContent">
                                <h4>Tailored to Your Needs</h4>
                                <p>We'll focus on the modules that matter most to your specific role and organization.</p>
                            </div>
                        </div>
                        <div className="seePranCard">
                            <div className="seepranImg"><img src={LiveQA} alt="Live QA" /></div>
                            <div className="seepranContent">
                                <h4>Live Q&A Session</h4>
                                <p>Get direct answers from our product experts and clinical leads</p>
                            </div>
                        </div>
                        <div className="seePranCard">
                            <div className="seepranImg"><img src={RoadMap} alt="Roadmap" /></div>
                            <div className="seepranContent">
                                <h4>Integration Roadmap</h4>
                                <p>Understand how Pran.AI integrates with your existing HMIS or government databases.</p>
                            </div>
                        </div>
                    </div>
                    <div className="seePranActionRightColum">
                        <div className="ScheduleWalkthroughForm">
                            <div className="schduleWalkHeader">
                                <h4>Schedule a Walkthrough</h4>
                                <p>Book a personalized demo to discover how our intelligent health ecosystem can transform your operations. </p>
                            </div>
                            <div className="schduleFormSection">
                                <form>
                                    <div className="row">
                                        <div className="col-xs-12 col-md-6">
                                            <div className="formGroup">
                                                <input type="text" placeholder="First Name " />  
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-6">
                                            <div className="formGroup">
                                                <input type="text" placeholder="Last Name " />  
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-12">
                                            <div className="formGroup">
                                                <input type="text" placeholder="Work email" />  
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-12">
                                            <div className="formGroup">
                                                <input type="text" placeholder="Phone Number" />  
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-12">
                                            <div className="formGroup">
                                                <input type="text" placeholder="Interest Product" />  
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-12">
                                            <div className="formGroup">
                                                <input type="text" placeholder="Organization name" />  
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-12">
                                            <div className="formGroup">
                                                <select>
                                                    <option value="">Organization Type</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-12">
                                            <div className="formGroup mb-2">
                                                <h6>Interest Module</h6>
                                                <div className="checkBoxModuleMain">
                                                    <div className="checkBoxModule">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
                                                        <label for="vehicle1"> Govt Dashboard</label>
                                                    </div>
                                                    <div className="checkBoxModule">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
                                                        <label for="vehicle1"> Patients App</label>
                                                    </div>
                                                    <div className="checkBoxModule">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
                                                        <label for="vehicle1"> HMIS / LIMS</label>
                                                    </div>
                                                    <div className="checkBoxModule">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
                                                        <label for="vehicle1"> PHR</label>
                                                    </div>
                                                    <div className="checkBoxModule">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
                                                        <label for="vehicle1"> Hospital Business</label>
                                                    </div>
                                                    <div className="checkBoxModule">
                                                        <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
                                                        <label for="vehicle1"> AI Chatbot</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-12">
                                            <div className="formGroup">
                                                <h6>Anything specific you would like to see? </h6>
                                                <textarea placeholder="Additional Message" rows="4"></textarea>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-md-12">
                                            <div className="formGroup">
                                                <button type="submit" className="submitBtn">Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer />
    </>
    );  
};

export default GetDemo;